import { Col, Row, Tabs, Empty } from "antd";
import "./style.css";
import { useEffect, useState } from "react";
import { getApis } from "../../Common/apis";
import { vehicleModelTreeViewUrl } from "../../Common/endpoints";
import TreeView from "./TreeView.js";
import ManufacturesTab from "./ManufacturersTab.js";
import AttributesTab from "./AttributesTab.js";

const VehicleModal = ({ selectedVehicle }) => {
  const authToken = localStorage.getItem("authToken");
  const [treeViewData, setTreeviewData] = useState([]);
  const [treeViewSelectedValue, setTreeViewSelectedValue] = useState("");

  const [manufacturerData, setManufacturerData] = useState([]);
  const [attributesData, setAttributesData] = useState([]);

  const getTreeViewDetails = async () => {
    setTreeViewSelectedValue("");
    setManufacturerData([]);
    setAttributesData([]);
    await getApis(
      vehicleModelTreeViewUrl,
      {
        imei: selectedVehicle.imei,
        vehicleModelId: selectedVehicle.vehicleModelId,
      },
      authToken
    )
      .then((response) => {
        setTreeViewSelectedValue([response?.data?.id] || []);
        setTreeviewData([response?.data] || []);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getTreeViewDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicle]);

  const handleTreeViewSelect = (e) => {
    if (!isNaN(+e[0])) {
      setTreeViewSelectedValue(e);
    }
  };

  return (
    <Row gutter={[16, 16]} className="vehicle-part-tree-view">
      <Col span={6}>
        <div className="tree-box-col h100">
          <div className="mb1 mt05">Tree View</div>
          {treeViewData.length !== 0 ? (
            <TreeView
              handleTreeViewSelect={handleTreeViewSelect}
              treeViewSelectedValue={treeViewSelectedValue}
              treedata={treeViewData}
            />
          ) : (
            <Empty className="empty-value" />
          )}
        </div>
      </Col>
      <Col span={18}>
        <div className="tab-box-col h100">
          <Tabs
            items={[
              {
                label: "Manufacturers",
                key: "1",
                children: (
                  <ManufacturesTab
                    vehiclePartId={treeViewSelectedValue}
                    setManufacturerData={setManufacturerData}
                    manufacturerData={manufacturerData}
                  />
                ),
              },
              {
                label: "Attributes",
                key: "2",
                children: (
                  <AttributesTab
                    vehiclePartId={treeViewSelectedValue}
                    setAttributesData={setAttributesData}
                    attributesData={attributesData}
                  />
                ),
              },
            ]}
          />
        </div>
      </Col>
    </Row>
  );
};
export default VehicleModal;
